import { sizeGap } from '../../util/constants';
export var emojiPickerHeightOffset = function emojiPickerHeightOffset(size) {
  if (size === 'medium') {
    return sizeGap;
  } else if (size === 'large') {
    return sizeGap * 2;
  }
  return 0;
};